// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jjQQQwWvtNsjhhhUi54T{z-index:var(--zIndex-OVERLAY_MAIN_2);background-color:var(--background-primary-inverted-primary);width:480px;box-shadow:var(--shadow-dropdown);border-radius:12px;padding:0 12px;position:fixed;bottom:32px;left:50%;transform:translate(-50%)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"imageInfo": `jjQQQwWvtNsjhhhUi54T`
};
export default ___CSS_LOADER_EXPORT___;
